export default __webpack_public_path__ + "static/media/Marcin Cnota.7f5a6226.webp";